import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";
import { BellIcon, CircleCheck, CircleClockIcon, ClockIcon } from "../../../../assets/icons";
import { MySurveySummaryDTO } from "../../../../models/my-survey-summary/my-survey-summary-dto";

const DraftLink = ({ customSummary, loading }: { customSummary: MySurveySummaryDTO; loading: boolean }) => {
  const tRP = "components.custom_widget_links.my_surveys.draft";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      mainInfo={customSummary?.draft?.toString() ?? "0"}
      description={`${t(`${tRP}`)}`}
      Icon={customSummary?.draft > 0 ? ClockIcon : CircleCheck}
      IconStyle={{
        color: customSummary?.draft > 0 ? theme.palette.error.main : theme.palette.success.light,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
      {...(customSummary?.draft > 0 && {
        animateIcon: true,
      })}
    />
  );
};
export default DraftLink;
